import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonicalUrl }) => {
  const fullTitle = title ? `${title} | VB Global` : 'Paper Chemicals Supplier in India | VB Global – Wet End Chemicals, Dyes, Construction Chemicals, SS Wire Mesh | Coimbatore';
  const defaultDescription = "VB Global - Leading supplier of eco-friendly paper chemicals, construction chemicals, SS wire mesh, high pressure showers & nozzles, and paper dyes in Coimbatore, India.";
  const defaultKeywords = "paper chemicals, construction chemicals, SS wire mesh, high pressure showers, paper dyes, optical brightening agents, paper mill suppliers, VB Global, Coimbatore";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};

export default SEO;
